import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import { SharedService } from "@shared/services/shared.service";
import { IBusiness, INotesViewModel } from "app/models/business/business";
import { BusinessService } from "app/services/business/business.service";
import { ComplaintService } from "app/services/complaint/complaint.service";
// import { AddCitationsComponent } from "./addCitations/addCitations.component";
import { IBusinessCitationView, IBusinessExemptInspectionsViewModel } from "app/models/mainMenu/mainMenu";
import { AuthService } from "@shared/auth/auth.service";
import { AnnualInspectionModalComponent } from "./annualInspectionModal/annualInspectionModal.component";
import { Subscription } from "rxjs";


@Component({
  selector: 'inspections',
  styleUrls: ['./annualInspections.component.scss'],
  templateUrl: './annualInspections.component.html'
})

export class InspectionsComponent implements OnInit {

  // Called from either the Complaint(0) or Business(1) components
  @Input() parentPanel: number = 0;

  businessSubscription: Subscription;
  currentBusiness: IBusiness = {} as IBusiness;
  inspectionList: IBusinessExemptInspectionsViewModel[] = [];
  complaintCount: number = 0;
  commentCount: number = 0;
  currentTab: number = 0;
  editBusinessFlag: boolean = false;
  businessName: string = '';
  businessId: number = 0;
  isAdmin: boolean = false;

  panelParent: string = '';

  displayedColumns: string[] = ['inspectionType', 'visitDate', 'followupConducted', 'visitConductedReason', 'action'];
  dataSource = new MatTableDataSource<IBusinessExemptInspectionsViewModel>(this.inspectionList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(
    private sharedService: SharedService,
    private businessService: BusinessService,
    private modalService: MatDialog
  ) {

  }

  ngOnInit(): void {
    this.businessSubscription = this.businessService.updateBusinessEvent.subscribe((data: number) => {
      if (data == 6) {
        this.businessId = this.businessService.businessId;
        this.getAnnualInspections(this.businessId);
      }
    });
  }
  
  ngOnDestroy() {
    this.businessSubscription.unsubscribe();
  }

  getAnnualInspections(businessId: number) {
    this.businessService.getAnnualInspections(businessId).subscribe({
      next: response => {
        this.inspectionList = response;
        this.dataSource.data = this.inspectionList;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Annual Inspections Info");
      },
    });
  }

  add() {
    // let citation = {} as IBusinessCitationView;
    this.editInspection(null);
  }

  deleteInspection(inspection: IBusinessExemptInspectionsViewModel) {
    this.sharedService.openConfirm("Are you sure you want to delete this inspection?");
    this.sharedService.confirmed().subscribe(
      confirmed => {
        if (confirmed) {
          this.businessService.removeInspection(inspection.businessFollowupSiteVisitId).subscribe({
            next: response => {
              this.sharedService.toastr.success("Inspection Deleted");
              this.getAnnualInspections(this.businessId);
            },
            error: e => {
              this.sharedService.toastr.error("Could not delete Inspection");
            },
          });
        }
      }
    );
  }

  editInspection(inspection: IBusinessExemptInspectionsViewModel) {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 800;
    config.maxHeight = 600;
    config.data = {
      modalInspection: inspection,
      businessId: this.businessId
    };
    const dialogRef = this.modalService.open(AnnualInspectionModalComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.getAnnualInspections(this.businessId);
        }
      },
      error => this.sharedService.toastr.error("Could not add business comments: " + error.message),
      () => { }
    );
  }

}